export const recentPurchases = [
  { name: 'Emily J.', city: 'Austin', country: 'United States', time: '2 minutes ago' },
  { name: 'Lucas F.', city: 'Lisbon', country: 'Portugal', time: '5 minutes ago' },
  { name: 'Hannah K.', city: 'Munich', country: 'Germany', time: '8 minutes ago' },
  { name: 'Mateo R.', city: 'Buenos Aires', country: 'Argentina', time: '11 minutes ago' },
  { name: 'Olivia B.', city: 'Melbourne', country: 'Australia', time: '14 minutes ago' },
  { name: 'Ricardo M.', city: 'Mexico City', country: 'Mexico', time: '17 minutes ago' },
  { name: 'Chloe D.', city: 'Montreal', country: 'Canada', time: '21 minutes ago' },
  { name: 'Aisha N.', city: 'Dubai', country: 'United Arab Emirates', time: '25 minutes ago' },
  { name: 'Javier P.', city: 'Santiago', country: 'Chile', time: '29 minutes ago' },
]
